<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {SearchKind} from "@/modules/redactor/models/search/SearchKind";

export default {
  name: "r-search-kind",
  props: {
    model: VueTypes.instanceOf(SearchKind),
    label: VueTypes.string.def("Search:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SearchKind.getValues();
    }
  }
}
</script>